import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { HomeSection } from "./sections/HomeSection";
import { HeroSection } from "./sections/HeroSection";
import { BlogsSection } from "./sections/BlogsSection";
import { ProductsSection } from "./sections/ProductsSection";
import { WarriorSection } from "./sections/WarriorSection";
import { AboutSection } from "./sections/AboutSection";
import { ContactSection } from "./sections/ContactSection";
import { AdminPage } from "./pages/AdminPage";

function LandingPage() {
  return (
    <>
      {/* Global Fixed Video Background - Behind Everything */}
      <div className="fixed inset-0 w-full h-full -z-10 overflow-hidden" data-testid="global-video-bg">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="https://videos.pexels.com/video-files/6299083/6299083-uhd_2560_1440_25fps.mp4" type="video/mp4" />
          <source src="https://videos.pexels.com/video-files/6299083/6299083-hd_1920_1080_25fps.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 noise-overlay opacity-[0.5] mix-blend-overlay pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/50 pointer-events-none" />
      </div>

      <Header />

      <div className="relative z-0">
        <HomeSection />
        <HeroSection />
        <BlogsSection />
        <ProductsSection />
        <WarriorSection />
        <AboutSection />
        <ContactSection />
      </div>
    </>
  );
}

function App() {
  return (
    <div className="App relative" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
